import Route from "@ember/routing/route";

export default class RemoteHandsCreateRoute extends Route {
  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  model() {
    return { project: this.modelFor("organization").project };
  }
}
